import { batch } from "react-redux";
import {
  accessTokenCookieName,
  refreshTokenCookieName,
} from "../../common/config";
import {
  resetProfile,
  setProfileId,
} from "../../participantProfile/actions/profileActions";
import { getErrorMessageFromRequestError } from "../../shared/helpers/messages/request";
import { loginCookies } from "../../shared/utils/auth";
import { loginService, loginToken } from "../services";
import {
  IS_FETCHING_LOGIN,
  IS_SUBSCRIPTION_INACTIVE,
  SET_AUTH_ID,
  SET_IS_LOGIN_ERROR,
  SET_LOGIN_ERROR_MESSAGE,
  SET_ORGANIZATION_ACCOUNT,
  SET_PARTICIPANT,
} from "./actions-types";

export const setIsFetchingLogin = ({ isFetching }) => ({
  type: IS_FETCHING_LOGIN,
  payload: { isFetching },
});

export const setIsLoginError = ({ isError }) => ({
  type: SET_IS_LOGIN_ERROR,
  payload: { isError },
});

export const setLoginErrorMessage = ({ errorMessage }) => ({
  type: SET_LOGIN_ERROR_MESSAGE,
  payload: { errorMessage },
});

export const setAuthId = (authId) => ({
  type: SET_AUTH_ID,
  payload: { authId },
});

export const setParticipant = (participant) => ({
  type: SET_PARTICIPANT,
  payload: participant,
});

export const setOrganization = ({ id, name, settings }) => ({
  type: SET_ORGANIZATION_ACCOUNT,
  payload: {
    organization: {
      id,
      name,
      settings,
    },
  },
});

export const openSubscriptionModal = (subscriptionStatus) => ({
  type: IS_SUBSCRIPTION_INACTIVE,
  payload: subscriptionStatus,
});

export const setLoginData = (data) => async (dispatch) => {
  const {
    data: {
      accessToken,
      refreshToken,
      userProfileId,
      organizationId,
      organizationName,
      organizationSettings,
    },
  } = data;

  batch(() => {
    dispatch(
      setOrganization({
        id: organizationId,
        name: organizationName,
        settings: organizationSettings,
      })
    );
    dispatch(setAuthId(userProfileId));
  });

  loginCookies.set(accessTokenCookieName, accessToken);
  loginCookies.set(refreshTokenCookieName, refreshToken);
};

export const login =
  ({ username, password, isTokenProvided = false }) =>
  async (dispatch) => {
    batch(() => {
      dispatch(setIsFetchingLogin({ isFetching: true }));
      dispatch(setIsLoginError({ isError: false }));
      dispatch(openSubscriptionModal(false));
      dispatch(
        setParticipant({
          profileId: "",
          name: "",
          lastName: "",
          subscriptionStatus: "",
          email: "",
        })
      );
      dispatch(resetProfile());
    });

    try {
      const response = isTokenProvided
        ? await loginToken({
            accessToken: decodeURIComponent(username),
            refreshToken: decodeURIComponent(password),
          })
        : await loginService({ username, password });

      if (!response) {
        batch(() => {
          dispatch(setIsLoginError({ isError: true }));
          dispatch(setLoginErrorMessage({ errorMessage: "Unexpected Error" }));
        });
        return;
      }

      const { userProfileId, name, lastName, subscriptionStatus, userName } =
        response.data.data;

      batch(() => {
        dispatch(
          setParticipant({
            profileId: userProfileId,
            name,
            lastName,
            subscriptionStatus,
            email: userName,
          })
        );
        dispatch(setLoginData(response.data));
        dispatch(setProfileId(userProfileId));
      });
    } catch (e) {
      const errorMessage = getErrorMessageFromRequestError(e);

      if (errorMessage.indexOf("subscription") > -1) {
        batch(() => {
          dispatch(openSubscriptionModal(true));
          dispatch(
            setParticipant({
              profileId: e?.response?.data.data.userProfileId,
              name: e?.response?.data.data.name,
              lastName: e?.response?.data.data.lastName,
              subscriptionStatus:
                e?.response?.data.data.subscriptionStatus || "canceled",
              email: username,
            })
          );
        });
      }

      batch(() => {
        dispatch(setIsLoginError({ isError: true }));
        dispatch(setLoginErrorMessage({ errorMessage }));
      });

      loginCookies.remove(accessTokenCookieName);
      loginCookies.remove(refreshTokenCookieName);
    } finally {
      dispatch(setIsFetchingLogin({ isFetching: false }));
    }
  };
